<template> 
  <div class="body-wrapper">
    <a href="https://wa.me/6594363876" target="_blank" class="btn-wa">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48"><path fill="none" d="M0 0h24v24H0z"/><path d="M2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 0 0-.371.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 0 0 3.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 0 0-.177-.041.482.482 0 0 0-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 0 1-.368.13 1.416 1.416 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 0 1-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 0 0 .263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004z" fill="rgba(35,205,100,1)"/></svg>
    </a>
    <div class="w-full thankyou-bg">
      <div class="container px-4 pt-6">
        <div class="w-full flex pt-4 pb-4">
          <div class="w-3/6 md:w-4/12 lg:w-4/12">
                <router-link class="m-auto" to="/"><img class="m-auto md:m-0" src="/images/logo.png"></router-link>
          </div>              
          <div class="w-5/6 md:w-6/10 lg:w-7/12 text-left flex items-center justify-end">                
            <div class="pr-0 block md:block">
                  <img class="w-5/6 hidden lg:block" src="/images/tel-icon.png">
                  <img class="w-5/6 block lg:hidden" src="/images/tel-icon.png">
            </div>
            <div class="block">
              <div class="font-bold lg:text-2xl text-gray-800">Call us at<br><a href="tel:+6567471910">(+65) 6747 1910</a></div>            
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full bg-whitesection ">
      <div class="container pt-24 pb-24 md:pt-32 md:pb-32 lg:pt-64 lg:pb-64 text-center">
        <div class="text-xl md:text-4xl text-gray-700 font-bold mb-3">MESSAGE SENDING SUCCESSFUL!</div>
        <div class="text-base text-gray-800 mb-12">Thank you for your kind interest in Atrex Services Pte Ltd. We will get back to you as soon as possible.</div>
        <div class="flex"><router-link class="m-auto" to="/"><div class="red-btn">Back To Home</div></router-link></div>
      </div>
    </div>
    <div class="w-full bg-white pt-5 pb-8 border-t-2 border-gray-300">
      <div class="container text-center">
        <div class="w-full text-gray-800 text-sm">Website maintained by Activa Media. All right reserved.</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-wa {
  background-color: #f2f2f2;
  border-radius: 100%;
  position: fixed;
  padding: 8px;
  bottom: 15px;
  right: 15px;
  z-index: 100;
}
</style>

<script>
  export default {
    mounted () {
      // Event snippet for Conversion Code conversion page
      // eslint-disable-next-line
      // gtag('event', 'conversion', {'send_to': 'AW-123456789/sdferyrwerxxdegtere'});
    }
  }
</script>